import { ReturnHistory } from 'types';
import { convertTimestampToDate } from 'helpers';

export function returnHistoryEntryFactory(data: any = {}): ReturnHistory {
  const { date, description, employeeName, type } = data;

  return {
    date: convertTimestampToDate(date || 0),
    description: description || '',
    employeeName: employeeName || '',
    type: type || '',
  };
}

export function returnHistoryFactory(data: any[] = []): ReturnHistory[] {
  const formattedData = data.map((entry: any) =>
    returnHistoryEntryFactory(entry)
  );

  return formattedData;
}
